module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n';
 var widthPercentString = widthPercent + '%'; ;
__p += '\n<div class="OneADIFaces-container">\n   ';
 for(var i=0; i<faces.row.length; i++) { ;
__p += '\n   	<div class="OneADIFaces-row">\n         ';
 _.forEach(faces.row[i], function(faceImageFile) {
            var lookAtThisFace = faceImageFile.default;

            ;
__p += '<img class="OneADIFaces-face" style=\'width: ' +
__e( widthPercentString ) +
'\' src="' +
__e( lookAtThisFace ) +
'">\n\n            </img>';
 }) ;
__p += '\n   	</div>\n   ';
 } ;
__p += '\n</div>\n';

}
return __p
};
